// extracted by mini-css-extract-plugin
export default {"community":"Community_community__elqey","title":"Community_title__rLmD3"};